import { Component, Input, OnChanges, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss']
})
export class ToggleSwitchComponent implements OnChanges {

  @Input() titulo: string;
  @Input() estados: any[] = [];
  @Input() cores: string[] = [];
  @Input() infoEstado: string[] = [];
  @Output() tsModelChange: EventEmitter<any> = new EventEmitter();
  @Input() tsModel: any;

  estadoAtualIndex: number = 0;

  constructor() { }

  ngOnChanges() {
    this.estadoAtualIndex = this.estados.findIndex(estado => estado === this.tsModel);
  }

  changeEstado() {
    this.estadoAtualIndex++;

    if (this.estadoAtualIndex === this.estados.length)
      this.estadoAtualIndex = 0;

    this.tsModelChange.emit(this.estados[this.estadoAtualIndex]);
  }
}
